/**
 * Memory Theme Palette
 *
 * Deliberately restrained: one violet accent used sparingly (brand marks,
 * active states) and everything else derived from the active theme's
 * neutral tokens. Provenance badges are neutral so the list reads calmly;
 * only the icon changes to tell the sources apart.
 */
export const getMemoryThemeColors = (isDark, colors = {}) => {
  const accent = isDark ? '#A78BFA' : '#6D28D9';
  const neutralFg = colors.text_color_secondary || (isDark ? '#A0A4A8' : '#4b4f55');
  const neutralBg = colors.solid_color_tertiary || (isDark ? '#1A1E22' : '#f0f2f5');
  const neutralBorder = colors.border_color_secondary || (isDark ? '#2A2E32' : '#ececed');

  const neutral = { fg: neutralFg, bg: neutralBg, border: neutralBorder };

  return {
    accent,
    accentBg: isDark ? 'rgba(167, 139, 250, 0.12)' : 'rgba(109, 40, 217, 0.07)',
    accentBorder: isDark ? 'rgba(167, 139, 250, 0.28)' : 'rgba(109, 40, 217, 0.18)',

    // Provenance: dream/learned carries the accent, the rest are neutral.
    learned: accent,
    learnedBg: isDark ? 'rgba(167, 139, 250, 0.12)' : 'rgba(109, 40, 217, 0.07)',
    learnedBorder: isDark ? 'rgba(167, 139, 250, 0.28)' : 'rgba(109, 40, 217, 0.18)',

    auto: neutral.fg,
    autoBg: neutral.bg,
    autoBorder: neutral.border,

    explicit: neutral.fg,
    explicitBg: neutral.bg,
    explicitBorder: neutral.border,

    import: neutral.fg,
    importBg: neutral.bg,
    importBorder: neutral.border,

    manual: neutral.fg,
    manualBg: neutral.bg,
    manualBorder: neutral.border,

    neutral,
    success: colors.color_success || '#22C55E',
    warning: '#F59E0B',
  };
};
